import api from './api';

export interface ReferredCustomer {
  id: number;
  user_id: number;
  first_name: string;
  last_name: string;
  referral_code: string | null;
  email: string | null;
  phone: string | null;
  joined_at: string;
}

export interface Referrer {
  id: number;
  user_id: number;
  first_name: string;
  last_name: string;
  referral_code: string;
  email: string | null;
  phone: string | null;
  created_at: string;
  referrals_count: number;
  referrals: ReferredCustomer[];
}

export interface ReferralStats {
  total_referrers: number;
  total_referred: number;
}

export interface ReferralFilters {
  search?: string;
  page?: number;
  limit?: number;
}

export interface ReferralsResponse {
  success: boolean;
  data: Referrer[];
  stats: ReferralStats;
  pagination: {
    total: number;
    page: number;
    limit: number;
    pages: number;
  };
}

const referralService = {
  async getReferrals(filters: ReferralFilters = {}): Promise<ReferralsResponse> {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));

    const response = await api.get(`/admin/referrals?${params.toString()}`);
    return response.data;
  },
};

export default referralService;
